import { Form as FormAntd, Typography as TypographyAntd } from 'antd';
import styled from 'styled-components';

export const Title = styled(TypographyAntd.Title)`
  font-size: 18px !important;
  color: #676a6c !important;
  font-weight: 700 !important;
`;

export const SubTitle = styled(TypographyAntd.Text)`
  margin-right: 10px;

  font-size: 12px !important;
  color: #696b6d !important;
  font-weight: normal !important;
`;

export const ItemForm = styled(FormAntd.Item)`
  label {
    font-weight: bold;
    font-size: 14px !important;
    color: #676a6c !important;
  }
`;
